import type { SVGProps } from 'react';

const SvgThreeDCube = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.0727 2.63648L22.6677 6.73148C23.5544 7.20982 23.5544 8.57482 22.6677 9.05315L15.0727 13.1482C14.396 13.5098 13.6027 13.5098 12.926 13.1482L5.33102 9.05315C4.44435 8.57482 4.44435 7.20982 5.33102 6.73148L12.926 2.63648C13.6027 2.27482 14.396 2.27482 15.0727 2.63648Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.21232 11.8176L11.2707 15.3526C12.1457 15.796 12.7057 16.6943 12.7057 17.6743V24.3476C12.7057 25.316 11.6907 25.9343 10.8273 25.5026L3.76898 21.9676C2.89398 21.5243 2.33398 20.626 2.33398 19.646V12.9726C2.33398 12.0043 3.34898 11.386 4.21232 11.8176Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.7883 11.8176L16.7299 15.3526C15.8549 15.796 15.2949 16.6943 15.2949 17.6743V24.3476C15.2949 25.316 16.3099 25.9343 17.1733 25.5026L24.2316 21.9676C25.1066 21.5243 25.6666 20.626 25.6666 19.646V12.9726C25.6666 12.0043 24.6516 11.386 23.7883 11.8176Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgThreeDCube;
